import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Container, MainHeading } from '../../globalStyles';
import { HeroVideo, HeroSection, HeroText, ButtonWrapper, HeroButton } from './HeroStyles';

const Hero = () => {
	return (
		<HeroSection>
			   
			<HeroVideo src="./assets/agil4it.jpg"  />
			
			<Container>
				<MainHeading>We create innovative Apps for Atlassian Jira</MainHeading>
				<HeroText>
				Our work consist in  the field of study that combines domain expertise, programming skills, and knowledge of mathematics and statistics to extract meaningful insights from data.In turn, these systems generate insights which analysts and business users can translate into tangible business value .
				</HeroText>
				<ButtonWrapper>
					<Link to="/applications">
						<Button style={{ backgroundColor: "#a6ba0d" }}>View our apps</Button>
					</Link>
					
				</ButtonWrapper>
			</Container>
		</HeroSection>
	);
};

export default Hero;
